<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>操作日志</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">操作日志</div>

        <div style="display: flex; margin-top: 15px">
          <el-input
            placeholder="请输入搜索的内容"
            size="small"
            class="marLeft"
            style="width: 200px"
            v-model="userName"
            clearable
          >
          </el-input>
          <el-button
            type="primary"
            size="small"
            @click="searchChick()"
            class="marLeft"
            >搜索</el-button
          >
        </div>
      </div>
      <!-- <div class="header-tool-box">
                <div class="htb-item" @click="hostExcelExportBack">
                    <i class="icon iconfont icon-downLoad2"></i>
                    <span>导出</span>
                </div>
            </div> -->
    </div>

    <div class="layout-content" style="background: transparent">
      <div v-if="list.length">
        <Table :columns="columns" :loading="loading" :data="list">
          <template slot-scope="{ row }" slot="userName">{{
            row.userName
          }}</template>
          <template slot-scope="{ row }" slot="inTime">
            {{ formatDateTime(row.inTime) }}
          </template>
          <template slot-scope="{ row }" slot="IP">
            {{ row.ip }}
          </template>
          <template slot-scope="{ row }" slot="context">
            <span class="ellipsis" :title="row.context">{{ row.context }}</span>
          </template>
        </Table>
        <div
          class="my-page"
          v-if="totalCount > pageSize"
          style="margin: 20px; text-align: center"
        >
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <div class="catalogue-content"></div>
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
  name: "exhibition-info-carApply",
  data() {
    return {
      newsAudit: "0",
      productTypeOptions: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      productTypeValue: "",

      modalDetail: false,
      loading: false,

      editBrand: false,
      editBrandnfo: null,
      editTopic: false,
      editTopicnfo: null,
      search: "",
      editInfo: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      columns: [
        {
          title: "操作人",
          slot: "userName",
          align: "center",
        },
        {
          title: "操作时间",
          slot: "inTime",
          align: "center",
        },
        {
          title: "IP",
          slot: "IP",
          align: "center",
        },
        {
          title: "操作内容",
          slot: "context",
          align: "center",
        },
      ],

      oppTime: [],
      searchField: "",
      list: [],
      selection: [], // 选中项目
      addShow: false,
      rejectModel: false,
      modelTitle: "",
      rowUser: {},
      showTabs: "0",
      PoptipTitle: "",
      option: {},
      stateInit: "",
      rejectValue: "",
      form: {
        category: [], // 展品分类
      },
      type: [],
      contactsList: [],
      tableList: [],
      idCategory: "",
      proIdType: "45866a37-7712-4177-8f77-0183d1357578",
      statusProType: ["wait"],
      excelOpt: {},
      userName: "",
    };
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      exhibitionInfo: "hostSetModule/getHostExhibition",
      hostExhibition: "hostSetModule/getHostExhibition",
    }),
  },
  created() {
    console.log(222222222222);
    document.title = "国药励展";
    this.initProType();
    this.init();
  },
  methods: {
    ...mapActions({
      applicationLogs: "hostSetModule/applicationLogs",
    }),
    formatDateTime(dateTimeString) {
      // 使用正则表达式替换 'T' 为空格，并删除 '.003'
      return dateTimeString.replace("T", " ").slice(0, 16);
    },
    switchBrand(name) {
      this.init();
    },

    initStatus() {
      if (this.newsAudit == 0) {
        this.statusProType = ["wait"];
      }
      if (this.newsAudit == 1) {
        this.statusProType = ["pass", "notpass"];
      }
      this.init();
    },
    searchChick() {
      this.init();
      //     this.startDateStr = this.formatDate(this.oppTime[0])
      //   this.endDateStr = this.formatDate(this.oppTime[1])
    },
    // 转换日期格式
    formatDate(dateTime) {
      let date = new Date(dateTime);
      let YY = date.getFullYear() + "-";
      let MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      //    return YY + MM + DD + " " + hh + mm + ss;
      return YY + MM + DD;
    },

    async init() {
      let a = [
        {
          type: 1,
          Wheres: {
            WhereOperator: 6,
            Label: "Cname",
            Value: `%${this.searchField || ""}%`,
          },
        },
      ];

      let pushList = this.searchField ? a : {};

      let pushList1 = [
        {
          type: 1,
          Wheres: {
            WhereOperator: 6,
            Label: "ProductCategory",
            Value: `%${this.searchField || ""}%`,
          },
        },
      ];

      // 观众|展商 VISIT|EXHIBIT
      this.option = {
        CompanyName: this.userName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        // Wheres: {}
        // Wheres: {
        //     type: 0,
        //     Wheres: {
        //         WhereGroupOperator: 0,
        //         Predicates: this.showTabs == 0 ? pushList : pushList1,
        //     },
        // },
      };
      this.excelOpt = this.option;
      this.loading = true;
      let proData = await this.applicationLogs(this.option);
      console.log(proData, "UserNameUserNameUserName");
      if (proData) {
        this.loading = false;
        let resList = proData.items;
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount;

        this.list = resList;
      } else {
        this.loading = false;
      }
    },

    // 查询产品类别
    async initProType() {
      let categoryData = await this.getProductByGroupId({
        groupId: this.hostExhibition.groupId,
        level: 0,
        loadChild: true,
      }); // 暂时先写死了值
      if (categoryData && categoryData.length) {
        categoryData.map((c) => {
          c.value = c.name;
          c.label = c.name;
          c.children = JSON.parse(JSON.stringify(c.list));
          c.children.map((v) => {
            v.value = v.name;
            v.label = v.name;
            v.children = JSON.parse(JSON.stringify(v.list));
            v.children.map((z) => {
              z.value = z.name;
              z.label = z.name;
              z.children = JSON.parse(JSON.stringify(z.list));
            });
          });
        });
        this.type = categoryData;
        console.log(this.type, "888888888");
      } else {
        this.type = [];
      }
    },

    async setAllAudit() {
      const reqList = [];
      if (!this.selection.length) return;
      this.selection.forEach((c) => {
        reqList.push(c.joinId);
      });
      const bool = await this.setOneStepAudit({
        joinIds: reqList,
      });
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    edit(item) {
      this.editInfo = item;
    },
    searchPro() {
      this.pageIndex = 1;
      this.init();
    },
    changeEvent(selection) {
      this.selection = selection;
    },
    async rejectP(row, index) {
      if (this.showTabs != 0) {
        this.contactsList = await this.getByCompId(row.compId);
        console.log(this.contactsList, "所有联系人");
      }
      this.tableList = await this.getAllBindsById(row.id);
      console.log(this.tableList, "ip和关注人");

      // getByCompId
      this.rejectValue = "";
      this.rowUser = row;
      this.modelTitle = "详情：";
      this.rejectModel = true;
      //   }
    },

    // 驳回确定按钮
    async handleSubmitReject() {
      if (!this.rejectValue) {
        this.$Message.warning("驳回理由不能为空！");
        return;
      }
      const option = {
        // id: this.rowUser.id,
        id: this.rowUser.id,
        setValues: {
          Remark: this.rejectValue,
          AuditStatus: "notpass",
        },
      };
      let bool = await this.getAuditLogPut(option);
      if (bool && bool.successed) {
        this.rejectModel = false;
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
      //   }
    },

    // 获取产品类别
    changeCategory(val) {
      let category = this.form.category;
      if (val) {
        category = this.form.category = val;
      }
      let data = null;
      this.type.forEach((c) => {
        if (category[0] && c.name === category[0]) {
          this.idCategory = c.id;
          data = {
            Id: c.id,
            Value: c.name,
            List: [],
          };
          if (c.list && c.list.length && category[1]) {
            c.list.forEach((v) => {
              if (v.name === category[1]) {
                this.idCategory = v.id;
                data.List[0] = {
                  Id: v.id,
                  Value: v.name,
                };
                if (v.list && v.list.length && category[2]) {
                  v.list.forEach((j) => {
                    if (j.name === category[2]) {
                      this.idCategory = j.id;
                      data.List[0].list = [
                        {
                          Id: j.id,
                          Value: j.name,
                          Remark: j.tag,
                        },
                      ];
                    }
                  });
                }
              }
            });
          }
        }
      });
      console.log(this.idCategory);
      return data;
    },

    // 修改展品显示、屏蔽
    async showToggle(item) {
      const bool = !!item.isShow;
      let result = await this.newRealeaseSetIsShow({
        id: item.id,
        setValues: {
          IsShow: bool,
        },
      });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },

    // 展商导出
    async hostExcelExportBack() {
      let res = await this.InformationGatheringExcelExport(this.excelOpt);
      let filename = "邀请函统计导出.xlsx";
      const blob = new Blob([res], { type: "application/vnd.ms-excel" }); // 构造一个blob对象来处理数据，并设置文件类型
      if (window.navigator.msSaveOrOpenBlob) {
        // 兼容IE10
        navigator.msSaveBlob(blob, filename);
      } else {
        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href; // 指定下载链接
        a.download = filename; // 指定下载文件名
        a.click();
        URL.revokeObjectURL(a.href); // 释放URL对象
      }
      this.$Message.success("导出成功，耐心等待");
    },
  },
};
</script>
  
<style scoped lang="scss">
.ellipsis {
  display: block;
  // width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.catalogue {
  .header-tool {
    min-height: 90px;
  }

  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}

.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}

.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}

.deleteClass {
  color: #f78989;
  // cursor:pointer;
}

.lookClass {
  color: #1890ff;
  cursor: pointer;
}

.marLeft {
  margin-left: 15px;
}
</style>
  